import styled from 'styled-components';
import { Link } from 'gatsby';
import { metrics, fonts, colors } from '@/theme';

const { mobile } = metrics;

export const Container = styled.footer`
  display: flex;
  justify-content: space-between;
  border-top: solid 1px ${colors.black};
  padding-top: 5px;
  margin-top: 70px;
  @media (max-width: ${mobile}px) {
    display: none;
  }
`;

export const Column = styled.ul`
  margin: 0;
  padding: 0;
`;

export const Title = styled.li`
  list-style: none;
  ${fonts.getSmallText()}
  margin-bottom: 15px;
`;

export const LinkItem = styled(Link)`
  ${fonts.getRegularText()}
  transition: color .5s;
  :hover {
    color: ${colors.blue};
  };
  color: ${colors.black};
  text-decoration: none;
`;

export const ExternalLinkItem = styled.a`
  ${fonts.getRegularText()}
  color: ${colors.black};
  text-decoration: none;
  transition: color .5s;
  &:hover {
    color: ${colors.blue};
  }
`;

export const Item = styled.li`
  list-style: none;
  ${fonts.getRegularText()}
`;
